import type * as React from "react"

interface Props extends React.SVGProps<SVGSVGElement> {
  isSelected?: boolean
}

export function EventsIcon({ isSelected, ...props }: Props) {
  return (
    <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      className="fill-black dark:fill-white"
      {...props}
    >
      <title>Events</title>
      {isSelected ? (
        <>
          <path
            d="m15.85,6.52l-1.73-1.73c-.19-.19-.51-.2-.71,0-.76.75-1.64.53-2.19-.01-.55-.55-.77-1.45-.02-2.2.19-.2.19-.51,0-.71l-1.73-1.73C9.38.05,9.26,0,9.12,0s-.26.05-.35.15L.15,8.77c-.2.2-.2.51,0,.71,0,0,1.62,1.62,1.72,1.72,0,0,0,0,0,0,0,0,0,0,0,0,.07.06.15.11.24.13.17.04.34,0,.47-.13.02-.02.04-.04.06-.06.74-.67,1.59-.45,2.13.08.55.55.77,1.44.02,2.19-.19.2-.19.51,0,.71l1.73,1.73c.09.09.22.15.35.15s.26-.05.35-.15L15.85,7.23c.09-.09.15-.22.15-.35s-.05-.26-.15-.35Zm-8.73-.34c-.16,0-.32-.06-.44-.18-.06-.06-.1-.13-.13-.2-.04-.08-.05-.16-.05-.24s0-.16.05-.24c.03-.08.08-.15.13-.2.24-.24.65-.24.89,0,.11.11.18.27.18.44,0,.08-.02.16-.05.24-.03.07-.08.14-.13.2-.12.12-.28.18-.45.18Zm3.55,2.11c.08.03.15.08.2.13.12.12.19.28.19.45,0,.16-.07.32-.19.44-.05.06-.12.1-.2.13-.07.04-.16.05-.24.05-.16,0-.32-.06-.44-.18s-.19-.28-.19-.44c0-.17.07-.33.19-.45.18-.17.45-.23.68-.13Zm-1.47-1.54c.25.23.27.63.03.88-.12.13-.29.2-.46.2-.15,0-.3-.06-.42-.17-.25-.23-.27-.63-.04-.89.23-.25.63-.27.88-.04h0Z"
            fill="#0ad78f"
            strokeWidth={0}
          />
        </>
      ) : (
        <>
          <path
            d="m15.85,6.52l-1.8-1.8c-.2-.2-.51-.2-.71,0-.57.57-1.5.57-2.07,0-.28-.28-.43-.64-.43-1.04s.15-.76.43-1.03c.09-.09.15-.22.15-.35s-.05-.26-.15-.35l-1.8-1.8c-.2-.2-.51-.2-.71,0L.15,8.77c-.2.2-.2.51,0,.71l1.8,1.8c.19.19.52.19.71,0,.55-.55,1.52-.55,2.07,0,.57.57.57,1.5,0,2.07-.2.2-.2.51,0,.71l1.8,1.8c.1.1.23.15.35.15s.26-.05.35-.15L15.85,7.23c.09-.09.15-.22.15-.35s-.05-.26-.15-.35ZM6.88,14.79l-1.13-1.13c.63-.96.52-2.25-.32-3.09-.81-.81-2.16-.93-3.09-.32l-1.13-1.13L9.12,1.21l1.13,1.13c-.26.4-.4.86-.4,1.35,0,.66.26,1.28.72,1.74.84.84,2.14.94,3.09.32l1.13,1.13-7.92,7.92Z"
            strokeWidth={0}
          />
          <path
            d="m7.75,5.56c0-.17-.06-.33-.18-.44-.06-.06-.13-.11-.2-.14-.23-.1-.51-.03-.68.14-.12.11-.19.28-.19.44s.07.32.19.44c.11.12.27.18.44.18.16,0,.33-.06.44-.18,0,0,0,0,0,0,.12-.11.18-.27.18-.44Z"
            strokeWidth={0}
          />
          <path
            d="m9.22,6.77c-.25-.25-.64-.25-.89,0,0,0,0,0,0,0-.24.24-.24.64,0,.88.13.12.29.18.45.18s.32-.06.44-.18c0,0,0,0,0,0,.24-.24.24-.64,0-.88Z"
            strokeWidth={0}
          />
          <path
            d="m10.88,8.43c-.23-.23-.64-.24-.88,0,0,0,0,0,0,0-.05.05-.1.12-.13.2s-.05.16-.05.24.02.16.05.24c.03.07.08.14.13.2.12.12.28.18.44.18.17,0,.33-.06.45-.18.05-.06.1-.13.13-.2.03-.08.05-.16.05-.24s-.02-.16-.05-.24c-.03-.08-.07-.15-.13-.2Z"
            strokeWidth={0}
          />
        </>
      )}
    </svg>
  )
}
